<template>
    <div>
        <p v-show="!rows.length && !hideEmpty">
            {{ lang.polaris.form.currently_no_link }}
        </p>

        <trax-ui-simple-table :id="id" :header="0" :rows="rows" :cols="cols" :bus="bus" v-show="rows.length">
        </trax-ui-simple-table>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            learningUnitId: null,
            endpoint: null,
            endpointParams: null,
            bus: null,
            editing: null,
            hideEmpty: null
        },

        data: function() {
            var cols = [{width: '60px', class: 'text-center'}, {}];
            if (this.editing) cols.push({width: '90px', padding: '0px', class: 'text-right commands'});
            return {
                lang: lang,
                resources : [],
                cols: cols,
                rows: [],
            }
        },

        created: function() {
            this.bus.$on(this.id+'-edit-create-or-update', this.createOrUpdate);
            this.bus.$on(this.id+'-delete-confirmed', this.deleteConfirmed);
            this.load();
        },

        mounted: function() {
            var that = this;

            $('#'+this.id+'-table tbody').on( 'click', '.btn.edit', function() {
                that.edit($(this).data('id'));
            });

            $('#'+this.id+'-table tbody').on( 'click', '.btn.delete', function() {
                that.delete($(this).data('id'));
            });
        },
        
        methods: {
        
            edit(id) {
                let resource = this.resources.find(resource => resource.id == id)
                this.bus.$emit(this.id+'-edit-open', resource);
            },

            delete(id) {
                this.bus.$emit(this.id+'-delete-open', {data: id});
            },

            deleteConfirmed(id) {
                var that = this;
                axios.delete(this.endpoint + '/' + id).then(function (response) {
                    that.load();
                })
            },

            createOrUpdate(data) {
                if (data.id) this.update(data);
                else this.create(data);
            },

            create(data) {
                var that = this;
                data.learning_unit_id = this.learningUnitId
                axios.post(this.endpoint, data).then(function (response) {
                    that.load();
                })
            },

            update(data) {
                var that = this;
                axios.put(this.endpoint + '/' + data.id, data).then(function (response) {
                    that.load();
                })
            },

            load() {
                var that = this;
                axios.get(this.endpoint, { params: this.endpointParams })
                    .then(function (response) {
                        that.resources = response.data.data;
                        that.updateRows();
                    })
            },

            updateRows() {
                this.rows = this.resources.map(resource => {
                    let row = [this.htmlIcon(resource), this.htmlName(resource)]
                    if (this.editing) {
                        row.push(this.htmlCommands(resource))
                    }
                    return row
                })
            },


            //------------------------------- Columns rendering ----------------------------//


            htmlIcon(resource) {
                return this.htmlLink(resource.href, '<i class="material-icons">link</i>');
            },

            htmlName(resource) {
                return this.htmlLink(resource.href, resource.name);
            },

            htmlCommands(resource) {

                // Edit.
                var html = '<button type="button" class="btn btn-link btn-just-icon mt-0 mb-0 edit" data-id="'+resource.id+'">';
                html += '       <i class="material-icons">edit</i>';
                html += '   </button>';

                // Delete.
                html += '<button type="button" class="btn btn-link btn-just-icon mt-0 mb-0 delete" data-id="'+resource.id+'">';
                html += '       <i class="material-icons">clear</i>';
                html += '   </button>';
                
                return html;
            },

            htmlLink(href, content) {
                return '<a href="'+href+'" target="_blank">'+content+'</a>';
            }
        }
    }
</script>
